module.exports = __webpack_public_path__ + "img/register_2.fd73b28d.png";